var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar--settings_svg__clip0_61530_7390)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 17.25v-1.5h-1.567a4.47 4.47 0 00-.769-1.853l1.109-1.11-1.06-1.06-1.11 1.109a4.47 4.47 0 00-1.853-.768V10.5h-1.5v1.568a4.469 4.469 0 00-1.853.768l-1.11-1.109-1.06 1.06 1.109 1.11a4.472 4.472 0 00-.768 1.853H10.5v1.5h1.568c.112.668.375 1.302.768 1.853l-1.109 1.11 1.06 1.06 1.11-1.109a4.47 4.47 0 001.853.768V22.5h1.5v-1.567a4.469 4.469 0 001.853-.769l1.11 1.109 1.06-1.06-1.109-1.11a4.47 4.47 0 00.768-1.853H22.5zm-6 2.25a3 3 0 110-5.999 3 3 0 010 5.999z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5A1.5 1.5 0 0019.5 3h-3V1.5H15V3H9V1.5H7.5V3h-3A1.5 1.5 0 003 4.5v15A1.5 1.5 0 004.5 21h3v-1.5h-3v-15h3V6H9V4.5h6V6h1.5V4.5h3V9H21V4.5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar--settings_svg__clip0_61530_7390"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgCalendarSettings;